// eslint-disable-next-line import/prefer-default-export
/* istanbul ignore file */
export const deviceTypes = {
  PHONE: 'PHONE',
  TABLET: 'TABLET',
  DESKTOP: 'DESKTOP',
  DESKTOPALT: 'DESKTOPALT',
  PHONEALT1: 'PHONEALT1',
  PHONEALT2: 'PHONEALT2',
};

export const BREAKPOINTS = {
  [deviceTypes.PHONE]: { max: 599 },
  [deviceTypes.TABLET]: { min: 600, max: 1023 },
  [deviceTypes.DESKTOP]: { min: 1024 },
};

export const deviceProductsPerRow = {
  [deviceTypes.PHONE]: 2,
  [deviceTypes.TABLET]: 4,
  [deviceTypes.DESKTOP]: 4,
  [deviceTypes.DESKTOPALT]: 6,
  [deviceTypes.PHONEALT1]: 3,
  [deviceTypes.PHONEALT2]: 1,
};

export const pageTypes = {
  SUBSPLASH: 'SUB_SPLASH',
  BROWSE: 'BROWSE',
  SEARCH: 'SEARCH',
  SPLASH: 'SPLASH',
  BRANDINDEX: 'BRAND_INDEX',
  BRANDSCATEGORYPAGE: 'BRANDSCATEGORYPAGE',
};

export const pageTypesLiteral = {
  subSplash: 'subSplash',
  zeroSearchResults: 'zeroSearchResults',
  browse: 'browse',
  search: 'search',
  catSplash: 'catSplash',
  brandIndex: 'brandIndex',
  brandsCategoryPage: 'brandsCategoryPage',
};

export const midContClassNames = {
  LARGE12: 'large-12',
  LARGE9: 'large-9',
};

export const phoneNumbers = {
  mcom: '1-800-289-6229',
  bcom: '1-800-777-0000',
};

export const BOPS_NAME = 'Upc_bops_purchasable';
export const SDD_FACET = 'Upc_sdd_purchasable';

export const addToBagCookies = {
  signedIn: 'SignedIn',
  miscGCs: 'MISCGCs',
  lastReviewUsername: 'last_review_username',
  productsReviewed: 'products_reviewed',
  shippingCountry: 'shippingCountry',
  currency: 'currency',
  secureUserToken: 'secure_user_token',
  csl: 'CSL', // current store location
  bopsPickupInStore: 'BOPSPICKUPSTORE',
  zipCode: 'USERPC',
  bigTicketZipCode: 'BTZIPCODE',
  forwardPageURL: 'FORWARDPAGE_KEY',
};
